import React from 'react';
import { FormRangeWithInputField } from '@hvcgroep/design-system';

import { ACCURACY_PRICE, UNIT_PRICE } from '../../../config/constants';

interface Props {
  name: string;
  className?: string;
  label?: string;
  description?: string;
  tooltip?: string;
  min?: number;
  max?: number;
  required?: boolean;
  disabled?: boolean;
  onBlur?: () => void;
  allowDecimals?: boolean;
}

function getDecimalSeparatorForLocale() {
  const numberWithDecimalSeparator = 1.1;

  return numberWithDecimalSeparator
    .toLocaleString(navigator.language)
    .substring(1, 2);
}

const decimalSeperator = getDecimalSeparatorForLocale();

const FormPrice: React.FC<Props> = ({ name, ...props }) => (
  <FormRangeWithInputField
    name={name}
    accuracy={ACCURACY_PRICE}
    unit={UNIT_PRICE}
    placeholder={`0${decimalSeperator}00`}
    allowDecimals
    {...props}
  />
);

export default FormPrice;
